export default __webpack_public_path__ + "media/images/document-e874c113feb649b356a4c897b9129b87.svg";